import axios from "axios";
import { imgSrcToBlob } from "blob-util";
import moment from "moment";

export const requiredDefaultMessage = "Pertanyaan wajib diisi";

// Mirrors the school_category values the register/update endpoints accept
// (required|in:SMA,SMP,KAMPUS). Compared lowercase — the route param carries
// whatever RegistrationPage stored.
export const SCHOOL_CATEGORIES = ["sma", "smp", "kampus"];

export const urlToFile = (fileUrl: string, fileName: string) => {
  return new Promise(async (resolve, reject) => {
    await imgSrcToBlob(fileUrl, "image/png", "Anonymous")
      .then((blob) => {
        resolve(blob);
      })
      .catch((err) => {
        reject(JSON.stringify(err));
      });
  });
};

export const validateEmail = (value: string) => {
  const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  if (pattern.test(value)) return;

  return "Pastikan email kamu valid";
};

export const handleIsRequired = (value: string) => {
  if (value?.trim()?.length > 0) return;

  return requiredDefaultMessage;
};

export const checkFilledData = (data: any) => {
  let countFilledData = 0;

  Object.keys(data)?.forEach((item) => {
    if (typeof data?.[item] === "string") {
      if (data?.[item]?.trim()?.length > 0) countFilledData++;
    } else {
      if (!!data?.[item]) countFilledData++;
    }
  });

  return countFilledData;
};

export const getStringSafely = (value: string | undefined) => {
  return value ?? "";
};

export const getBirthDate = (value: string) => {
  return moment(value).format("YYYY-MM-DD");
};

export const validatePhoneNumber = (value: string) => {
  if (value?.trim()?.length >= 10 && value?.trim()?.length <= 14) return;

  return "Nomor handphone harus memiliki 10 - 14 karakter";
};

// The Kuliah (KAMPUS) category runs the same form as SMP/SMA, but institution
// wording has to switch from "sekolah" to "perguruan tinggi". Only labels
// change — field names and submitted values stay identical.
export const isKampusCategory = (category?: string) =>
  String(category ?? "").toLowerCase() === "kampus";

export const institutionLabel = (category?: string) =>
  isKampusCategory(category) ? "Perguruan Tinggi" : "Sekolah";

export const institutionLabelLower = (category?: string) =>
  isKampusCategory(category) ? "perguruan tinggi" : "sekolah";
